export function replaceQuotesMain(str, isEngSite) {
	return replaceToLiQuotes(replaceToDoubleQuotes(str), isEngSite);
}

export const replaceToDoubleQuotes = function (text) {
	let str = text;

	str = str.replace(/onclick="(.*)\((.*)\)/gm, function (match, fnName, fnArguments) {
		return `onclick="${fnName}(${fnArguments.replace(/'/gm, 'MAGIC_QUOTES')})`;
	});

	// Remove eng quotes
	//str = str.replace(/'|&laquo;|&raquo;|»|«|&ldquo;|&rdquo;|&bdquo;|“|”|&rsquo;|&lsquo;|‘|’|&prime;|„/gi, '"');
	// str = str.replace(/&laquo;|&raquo;|»|«|&ldquo;|&rdquo;|&bdquo;|“|”|&rsquo;|&lsquo;|„/gi, '"');
	str = str.replace(/MAGIC_QUOTES/gm, "'");

	return str;
};

export const replaceOtherEngQuotes = function (text) {
	return text.replace(/'|‘|’|&prime;|‛/gi, '"');
};

export const replaceToLiQuotes = function (text, isEngSite) {
	const el = document.createElement('div');

	el.innerHTML = text;

	for (let i = 0, l = el.childNodes.length; i < l; i++) {
		if (
			el.childNodes[i].tagName &&
			(el.childNodes[i].tagName.toLowerCase() === 'script' || el.childNodes[i].tagName.toLowerCase() === 'style')
		) {
			// Костыль, не обрабатываем script и style
		} else if (el.childNodes[i].tagName && el.childNodes[i].tagName.toLowerCase() === 'table') {
			const table = document.createElement('table');
			table.innerHTML = el.childNodes[i].innerHTML;

			for (let r = 0, lr = table.rows.length; r < lr; r++) {
				for (let c = 0, lc = table.rows[r].cells.length; c < lc; c++) {
					table.rows[r].cells[c].innerHTML = replaceToLiQuotes(table.rows[r].cells[c].innerHTML, isEngSite);
				}
			}

			el.childNodes[i].innerHTML = table.innerHTML;
		} else if (el.childNodes[i].hasChildNodes() && el.childNodes.length >= 1) {
			el.childNodes[i].innerHTML = replaceToLiQuotes(el.childNodes[i].innerHTML, isEngSite);
		} else {
			const isComment = el.childNodes[i].nodeName === '#comment';

			el.childNodes[i].textContent = isComment
				? el.childNodes[i].textContent
				: el.childNodes[i].textContent.replace(
						/&laquo;|&raquo;|»|«|&ldquo;|&rdquo;|&bdquo;|“|”|&rsquo;|&lsquo;|„/gi,
						'"',
				  );

			if (isEngSite === false) {
				el.childNodes[i].textContent = isComment
					? el.childNodes[i].textContent
					: el.childNodes[i].textContent
							.replace(/'|‘|’|&prime;|‛/gi, '"')
							.replace(/(\w)\x22(\w)/g, '$1\x27$2') // Цифробуквенный символ, двойная кавычка, цифробуквенный символ  (a"a -> a'a)
							.replace(/(^|\n|\s|—|-|\.|,|!|\?|:|;|\(|\\|\/)"/g, '$1«') // Начало строки, пробел и " заменяем «
							.replace(/"($|\n|\s|—|-|\.|,|!|\?|:|;|\)|\\|\/)/g, '»$1') // " начало строки и другие спец. символы в »
							.replace(/«\)/g, '»)') // «) -> »)
							.replace(/«( ?)/g, '«')
							.replace(/( ?)»/g, '»')
							.replace(/>"/g, '>«')
							.replace(/"</g, '»<')
							.replace(/$"/g, '«');
			}
		}
	}

	return el.innerHTML;
};
